import { render, staticRenderFns } from "./YoucontrolStep.vue?vue&type=template&id=60b6cfc0&scoped=true"
import script from "./YoucontrolStep.vue?vue&type=script&lang=js"
export * from "./YoucontrolStep.vue?vue&type=script&lang=js"
import style0 from "./YoucontrolStep.vue?vue&type=style&index=0&id=60b6cfc0&prod&lang=scss"
import style1 from "./YoucontrolStep.vue?vue&type=style&index=1&id=60b6cfc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6cfc0",
  null
  
)

export default component.exports